import * as React from "react";
import TextInput from "@ebsco-ui/text-input";
import { createBemBlockBuilder } from "@ebsco-ui/utils";
import cn from "classnames";

import "./date-range.scss";

interface DateObject {
  value: string;
  error?: string;
}
export type ChangeEventHandler = (minDate: string, maxDate: string) => void;

export interface DateRangeProps {
  className?: string;
  i18n: {
    minDateLabel: string;
    maxDateLabel: string;
  };
  isSharedError: boolean;
  minDate: DateObject;
  maxDate: DateObject;
  onChange: ChangeEventHandler;
  placeholder?: string;
  uniqueName: string;
}

const baseClassName = "eb-date-range";

export const DateRange = (props: DateRangeProps) => {
  const {
    minDate,
    maxDate,
    onChange,
    uniqueName,
    i18n: { minDateLabel, maxDateLabel },
    isSharedError,
    placeholder,
    className,
  } = props;

  const getBlocksWith = createBemBlockBuilder([baseClassName, className]);
  const inputBlockClassName = getBlocksWith("-input");

  const handleMinDateChange: React.ChangeEventHandler<HTMLInputElement> = ({
    target: { value: newMinDate },
  }) => {
    onChange(newMinDate, maxDate.value);
  };

  const handleMaxDateChange: React.ChangeEventHandler<HTMLInputElement> = ({
    target: { value: newMaxDate },
  }) => {
    onChange(minDate.value, newMaxDate);
  };

  return (
    <div
      className={cn(
        getBlocksWith(),
        // we need error state to be present, but without message, to avoid
        // message duplication for errors, related to both inputs.
        isSharedError && getBlocksWith("--shared-error"),
      )}
      data-auto="date-range"
    >
      <TextInput
        id={`${uniqueName}MinDateInput`}
        label={minDateLabel}
        value={minDate.value}
        error={minDate.error}
        onChange={handleMinDateChange}
        placeholder={placeholder}
        data-auto="date-range-min-date"
        className={inputBlockClassName}
      />
      <TextInput
        id={`${uniqueName}MaxDateInput`}
        label={maxDateLabel}
        value={maxDate.value}
        error={maxDate.error}
        onChange={handleMaxDateChange}
        placeholder={placeholder}
        data-auto="date-range-max-date"
        className={inputBlockClassName}
      />
    </div>
  );
};

export default DateRange;
